import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/model/rules.js";

const app = createApp(App);
app.config.globalProperties.productionTip = false;

app.use(router).use(store).mount("#app");
